import React from 'react';
import {Link} from "react-router-dom";

function Banner(){

	return(
	
		<>

<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="hero owl-carousel" id="hero">
							<div class="hero__slide" data-bg="/images/banner1.jpg">
								<h1 class="hero__title">Exclusive digital asset</h1>
								<p class="hero__text">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour.</p>
								<div class="hero__btns">
								<Link to="/item" class="hero__btn hero__btn--clr">More details</Link>
								<Link to="/item" class="hero__btn">Place a bid</Link>
								</div>
							</div>

							<div class="hero__slide" data-bg="/images/banner3.jpg">
								<h2 class="hero__title">Discover, collect, and sell extraordinary NFTs</h2>
								<p class="hero__text">Securely buy and sell unique digital collectibles. <br />Lowest transaction costs across all NFT markets guaranteed.</p>
								<div class="hero__btns">
									<Link to="/collectibles" class="hero__btn hero__btn--clr">Explore</Link>
									<Link to="/signin" class="hero__btn">Create</Link>
								</div>
							</div>

							<div class="hero__slide" data-bg="/images/banner1.png">
								<h2 class="hero__title">Crystal Cloud  – NFT Marketplace <br />HTML Template</h2>
								<p class="hero__text">Digital marketplace for crypto collectibles and non-fungible tokens. <br />Buy, sell, and discover exclusive digital assets.</p>
								<div class="hero__btns">
								<Link to="/collectibles" class="hero__btn hero__btn--clr">Explore</Link>
									<Link to="/signin" class="hero__btn">Create</Link>
								</div>
							</div>
						</div>

						<button class="main__nav main__nav--hero main__nav--prev" data-nav="#hero" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"/></svg></button>
						<button class="main__nav main__nav--hero main__nav--next" data-nav="#hero" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></button>
					</div>
				</div>
			</div>
		
 	
</>

);


}

export default Banner;